import { useTranslation } from "react-i18next";

const SHOW_TEMPLATE_CREATE_CARD = false;

function getDefaultReportTemplates(t) {
  return [
    {
      id: "ud1000-convergence-report",
      title: t("imageFileIndex.reportTemplateSlide.templates.ud1000.title", {
        defaultValue: "UD1000 Convergence Report",
      }),
      subtitle: t(
        "imageFileIndex.reportTemplateSlide.templates.ud1000.subtitle",
        {
          defaultValue: "Combined ultrasound, thermal, and UV findings.",
        },
      ),
      accent: "#0f766e",
      badge: t("imageFileIndex.reportTemplateSlide.templates.ud1000.badge", {
        defaultValue: "Default",
      }),
    },
    {
      id: "equipment-timeseries-report",
      title: t(
        "imageFileIndex.reportTemplateSlide.templates.timeseries.title",
        {
          defaultValue: "Equipment Timeseries Report",
        },
      ),
      subtitle: t(
        "imageFileIndex.reportTemplateSlide.templates.timeseries.subtitle",
        {
          defaultValue: "Compare changes over time for one asset.",
        },
      ),
      accent: "#b45309",
      badge: t(
        "imageFileIndex.reportTemplateSlide.templates.timeseries.badge",
        {
          defaultValue: "Recommended",
        },
      ),
    },
    {
      id: "electrical-duty-report",
      title: t(
        "imageFileIndex.reportTemplateSlide.templates.electricalSafety.title",
        {
          defaultValue: "Electrical Safety Report",
        },
      ),
      subtitle: t(
        "imageFileIndex.reportTemplateSlide.templates.electricalSafety.subtitle",
        {
          defaultValue: "Structured report for electrical safety review.",
        },
      ),
      accent: "#1d4ed8",
      badge: t(
        "imageFileIndex.reportTemplateSlide.templates.electricalSafety.badge",
        {
          defaultValue: "Safety",
        },
      ),
    },
  ];
}

function buildTemplateItems(defaultTemplates, customTemplates) {
  if (!Array.isArray(customTemplates) || customTemplates.length === 0) {
    return defaultTemplates;
  }

  return [...defaultTemplates, ...customTemplates];
}

export default function ReportTemplateSlide({
  templates = [],
  selectedId = "ud1000-convergence-report",
  onSelect,
  onCreateTemplate,
  title,
}) {
  const { t } = useTranslation();
  const defaultTemplates = getDefaultReportTemplates(t);
  const items = buildTemplateItems(defaultTemplates, templates);
  const resolvedTitle =
    title ||
    t("imageFileIndex.reportTemplateSlide.title", {
      defaultValue: "Report Template",
    });
  const selectedTemplate = items.find((item) => item.id === selectedId);

  return (
    <section className="reportTemplateSlide reportTemplateSlideBox fileTabSection">
      <div className="reportTemplateSlide header fileTabHeader fileTabHeader--report">
        <div className="fileTabHeader__copy">
          <h3>{resolvedTitle}</h3>
        </div>
        <div className="fileTabHeader__actions">
          <select
            aria-label={resolvedTitle}
            value={selectedTemplate ? selectedId : ""}
            onChange={(event) => {
              const item = items.find((candidate) => candidate.id === event.target.value);
              if (item) onSelect?.(item);
            }}
          >
            {!selectedTemplate && <option value="" disabled>{resolvedTitle}</option>}
            {items.map((item) => <option key={item.id} value={item.id}>{item.title}</option>)}
          </select>
          {SHOW_TEMPLATE_CREATE_CARD && (
            <button type="button" onClick={() => onCreateTemplate?.()}>
              {t("imageFileIndex.reportTemplateSlide.createTitle", { defaultValue: "Add template" })}
            </button>
          )}
        </div>
        {selectedTemplate?.subtitle && <p className="fileTabHeader__description">{selectedTemplate.subtitle}</p>}
      </div>
    </section>
  );
}
